import React from "react";

const SvgTestComplete = (props) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="8.9987" cy="8.9987" r="7.66667" fill="#42B040" stroke="white" stroke-width="2"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.8047 6.86323C11.5444 6.60288 11.1223 6.60288 10.8619 6.86323L8 9.72516L7.13807 8.86323C6.87772 8.60288 6.45561 8.60288 6.19526 8.86323C5.93491 9.12358 5.93491 9.54569 6.19526 9.80604L7.5286 11.1394C7.78895 11.3997 8.21106 11.3997 8.4714 11.1394C8.47152 11.1393 8.47163 11.1391 8.47174 11.139L11.8047 7.80604C12.0651 7.54569 12.0651 7.12358 11.8047 6.86323Z" fill="white"/>
  </svg>

);

export default SvgTestComplete;